export const BRAND_OPTIONS = [
    {
        label: 'J&J',
        value: 'J&J'
    },
    {
        label: 'J&J Innovative Medicine',
        value: 'GlobalInnovMed'
    }
]
